/*! bootstrap-offcanvas-sidebar 24-11-2014 */
$(document).ready(function(){$('[data-toggle="offcanvas"]').click(function(){$(".row-offcanvas").toggleClass("active")})});